import { Attribute, BelongsTo, JsonApiModel, JsonApiModelConfig } from 'angular2-jsonapi';
import { Address } from "./address";
import { Customer } from "./customer";
import { CustomerCategory } from "./customer-category";
import { PageMetaData } from './PageMetaData';

@JsonApiModelConfig({
  type: 'site',
  meta: PageMetaData
})
export class Site extends JsonApiModel {

  private static defaultColor = '505050';

  @Attribute()
  name: string;

  @Attribute()
  last_payment: Date;

  @Attribute()
  address: Address;

  @Attribute()
  telephone: string;

  @Attribute()
  email: string;


  @BelongsTo()
  customer: Customer;

  public get fullName() {
    return (this.customer != null) ? this.customer.name + " " + this.name : this.name;
  }

  @BelongsTo()
  category: CustomerCategory | null;

  @Attribute()
  next_appointment: Date | null;

  @Attribute()
  last_report: Date | null;

  get mapIcon() {

    return "https://chart.apis.google.com/chart?chst=d_map_pin_letter&chld=%E2%80%A2|"
    + ((this.category != null) ? this.category.color.replace("#","") : Site.defaultColor);
  }

}




// WEBPACK FOOTER //
// /home/markush/Projects/fieldsale-wingman-client/src/app/shared/models/site.ts